import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { ListRDataItemSortBy, ListRDataPaginatedItemsViewModel, SortOrder } from '../models';

@Component({
    selector: 'lib-rdata-results',
    templateUrl: './rdata-results.component.html',
    styleUrls: ['./rdata-results.component.scss'],
    standalone: false
})
export class RdataResultsComponent {
  @Input() results: Observable<ListRDataPaginatedItemsViewModel> = new Observable();
  @Input() sortBy: ListRDataItemSortBy;
  @Input() sortOrder: SortOrder | null;
  @Input() dataPageVersion: boolean = false;
  @Input() showAd: boolean = true;
  @Input() hidePagination: boolean = false;
  @Input() clickableResults: boolean = true;
  @Output() pageChange: EventEmitter<number> = new EventEmitter();
  @Output() sortChange: EventEmitter<[SortOrder | null, ListRDataItemSortBy | string]> = new EventEmitter();
  @Output() detailsClicked = new EventEmitter<string>()

  #router = inject(Router);
  #route = inject(ActivatedRoute);

  pageChangeEvent(newPageNumber: number) {
    this.pageChange.emit(newPageNumber);
  }

  sortChangeEvent(sortOrder: SortOrder | null, sortBy: ListRDataItemSortBy | string) {
    this.sortChange.emit([sortOrder, sortBy]);
  }
  
  showDetails(event: Event, contractid: string) {
    if(this.clickableResults) {
      if(this.dataPageVersion) {
        event.stopImmediatePropagation();
        this.detailsClicked.emit(contractid);
      }
      else {
        this.#router.navigate(['contract', contractid], {state: {previousPage: 'rdata'}, relativeTo: this.#route});
      }
    }
  }
}
